import { createContext, useContext, useSyncExternalStore } from "react";
import type { SyncState } from "@tovi/pos-sync";
import { Till } from "./till.ts";

/**
 * The till, as React sees it.
 *
 * `useSyncExternalStore` rather than a reducer: the queue lives outside React
 * and keeps running while a screen is unmounted, which is exactly the case
 * that hook is for.
 */

export const TillContext = createContext<Till | null>(null);

export function useTill(): { till: Till; state: SyncState } {
  const till = useContext(TillContext);
  if (!till) throw new Error("useTill must be used inside a TillProvider");

  const state = useSyncExternalStore(
    (listener) => till.subscribe(listener),
    () => till.state(),
    () => till.state(),
  );

  return { till, state };
}
